<template>
	<div class="index">
		<div class="content">
			<div class="title">{{ details.batchTitle }}</div>
			<div class="date">{{ details.createdAt }} 由 {{ details.creator }} 发布</div>
			<van-divider/>
			<div class="date-details">
				<span style="white-space: nowrap">发送时间：</span>
				<div style="width: 100%;">{{ details.sendTime }}</div>
			</div>
			<div class="date-details">
				<span style="white-space: nowrap">发送给：</span>
				<div style="width: 100%;">{{ String(details.sendRooms) || '暂无' }}</div>
			</div>
			<van-divider/>
			<div class="file-details">
				<span>发送内容：</span>
				<ul>
					<div v-for="(v,i) in details.content" :key="i">
						<li v-if="v.msgType == 'text'">{{ v.content }}</li>
						<li v-if="v.msgType == 'image'">
							<img :src="v.fullPath" alt="">
							<div>
								<span>{{ v.name }}</span>
								<i>图片</i>
							</div>
						</li>
						<li v-if="v.msgType == 'link'">
							<img :src="v.fullPath" alt="">
							<div>
								<span>{{ v.title }}</span>
								<i>{{ v.url }}</i>
							</div>
						</li>
						<li v-if="v.msgType == 'miniprogram'">
							<img :src="v.pic_url" alt="">
							<div>
								<span>{{ v.title }}</span>
								<i>小程序</i>
							</div>
						</li>
					</div>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import {roomMessageBatchSendShow} from "../../api/roomMessageBatchSend";

export default {
	data() {
		return {
			details: {}
		}
	},
	watch: {},
	created() {
		this.id = this.$route.query.id
		this.detailsData()
	},
	methods: {
		detailsData() {
			roomMessageBatchSendShow({batchId: this.id}).then(res => {
				this.details = res.data
			})
		}
	}
}
</script>

<style lang="less" scoped>
.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #fff;

	.content {
		background: #fff;
		padding: var(--base-px-12) var(--base-px-16);

		.title {
			color: #000;
			font-size: var(--base-px-18);

			width: var(--base-px-201);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;

		}

		.date {
			color: #939393;
			font-size: var(--base-px-12);
			margin-top: var(--base-px-5);
		}

		.date-details {
			display: flex;
			font-size: var(--base-px-13);
			margin-bottom: var(--base-px-5);

			span {
				color: #939393;
			}
		}

		.file-details {
			span {
				color: #939393;
				font-size: var(--base-px-13);
			}

			ul {
				li {
					background: #f4f5f7;
					min-height: var(--base-px-50);
					width: 100%;
					border-radius: var(--base-px-12);
					font-size: var(--base-px-14);
					/* padding: var(--base-px-7) var(--base-px-10); */
					display: flex;
					align-items: center;
					padding: 0 var(--base-px-12);
					margin-top: var(--base-px-10);

					div {
						display: flex;
						flex-direction: column;

						i {
							color: #939393;
							font-size: var(--base-px-12);
							font-style: normal;
						}

						span {
							color: #000;
							width: var(--base-px-201);
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}

					img {
						width: var(--base-px-45);
						margin: var(--base-px-10) 0px;
						border-radius: var(--base-px-3);
						margin-right: var(--base-px-7);
					}
				}
			}
		}
	}
}
</style>
